import { render, staticRenderFns } from "./domainManage.vue?vue&type=template&id=144ff850&scoped=true&"
import script from "./domainManage.vue?vue&type=script&lang=js&"
export * from "./domainManage.vue?vue&type=script&lang=js&"
import style0 from "./domainManage.vue?vue&type=style&index=0&id=144ff850&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144ff850",
  null
  
)

export default component.exports